import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";
import { fullRichtextControls } from "@/types/richtext-controls";

export const onsitePersonalizationInputs = [
  {
    name: "isInactivityModalEnabled",
    type: "boolean",
    required: true,
    defaultValue: false,
  },
  {
    name: "isQuickSwipeUpModalEnabled",
    type: "boolean",
    required: true,
    defaultValue: false,
  },
  {
    name: "title",
    type: "string",
    defaultValue: "Exclusive content",
    required: true,
  },
  {
    name: "description",
    type: "string",
    defaultValue:
      "This article is available only to Ploom Club members, to access it and benefit from earning points, please sign in to your Ploom account now.",
  },
  {
    name: "mainImage",
    required: true,
    type: "file",
    defaultValue: "",
    allowedFileTypes: IMAGE_FILE_TYPES,
  },
  {
    name: "imageAltText",
    type: "string",
    required: true,
    defaultValue: "alt text",
  },
  {
    name: "primaryButtonText",
    type: "string",
    required: true,
    defaultValue: "Go to checkout",
  },
  {
    name: "secondaryButtonText",
    type: "string",
    required: true,
    defaultValue: "Continue shopping",
  },
  {
    name: "isImageOnLeft",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "inactivityDelay",
    friendlyName: "Inactivity delay, sec",
    type: "string",
    enum: ["10", "20", "30", "40", "50", "60"],
    defaultValue: "20",
    required: true,
  },
  {
    name: "hideModalExpireTime",
    friendlyName: "Hide modal expire time, days",
    type: "string",
    enum: ["1", "2", "3", "4", "5", "6", "7"],
    defaultValue: "7",
    required: true,
  },
  {
    name: "paragraph",
    type: "richTextEditor",
    options: {
      controls: fullRichtextControls,
    },
  },
  {
    name: "couponContent",
    type: "object",
    required: true,
    defaultValue: {
      isCouponAvailable: false,
      coupon: "ABC123",
      copyCouponLabel: "Copy",
      couponHelperText:
        "Copy this code and paste it in the  promo code field at checkout",
    },
    subFields: [
      {
        name: "isCouponAvailable",
        type: "boolean",
      },
      {
        name: "coupon",
        type: "string",
      },
      {
        name: "copyCouponLabel",
        type: "string",
      },
      {
        name: "couponHelperText",
        type: "string",
      },
    ],
  },
] as const satisfies Inputs;

export const OnsitePersonalizationModalComponent: RegisteredComponent = {
  name: "Onsite Personalization Modal",
  component: dynamic(
    async () =>
      withValidation(
        onsitePersonalizationInputs,
        (await import("./OnsitePersonalizationModal"))
          .OnsitePersonalizationModal,
        "OnsitePersonalizationModal"
      ),
    { ssr: false }
  ),
  models: [getBuilderModelName("onsite-personalization-modal")],
  inputs: onsitePersonalizationInputs,
  canHaveChildren: true,
  defaultChildren: [],
};
